import { Box } from '@mantine/core';
import classes from './Badge.module.css';
import { ReactNode } from 'react';

export const Badge = ({
	type,
	children,
}: {
	type: 'SUCCESS' | 'ERROR';
	children: ReactNode;
}) => {
	return (
		<Box
			className={
				type == 'SUCCESS'
					? classes.containerSuccess
					: classes.containerError
			}
		>
			{children}
		</Box>
	);
};
